import React, {
  forwardRef,
  useImperativeHandle,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  Table,
  Tbody,
  Tr,
  Td,
  Th,
  Thead,
  Spinner,
  Text,
} from "@chakra-ui/react";
import axios from "axios";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Print_Pdf_Exam_details = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false);
  const [exams, setExams] = useState([]);
  const [categories, setCategories] = useState([]);
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(
    localStorage.getItem("selectedClass") || ""
  );
  const [error, setError] = useState(null);
  const printRef = useRef();
  const schoolName = sessionStorage.getItem("school_name");
  const schoolEmail = sessionStorage.getItem("school_email");
  const schoolAddress = sessionStorage.getItem("school_address");
  const schoolImage = sessionStorage.getItem("school_image_url");
  useImperativeHandle(ref, () => ({
    handlePrint,
  }));

  const fetchData = async (classId) => {
    try {
      const jwtToken = sessionStorage.getItem("jwt");
      if (!jwtToken) throw new Error("JWT token not found");

      setLoading(true);

      const [examsRes, categoriesRes, classesRes] = await Promise.all([
        axios.get(`${BASE_URL}/admin/exam/list_all_exams.php`, {
          headers: { Authorization: `Bearer ${jwtToken}` },
        }),
        axios.get(`${BASE_URL}/admin/exam/exam_category.php`),
        axios.get(`${BASE_URL}/admin/class/class_master.php`),
      ]);

      const filteredExams = examsRes.data.data.filter(
        (exam) => exam.class_id === classId
      );

      setExams(filteredExams || []);
      setCategories(categoriesRes.data.data || []);
      setClasses(classesRes.data.data || []);
    } catch (error) {
      setError("Error fetching exam data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(selectedClass);
  }, [selectedClass]);

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`<div>${content}</div>`);
    iframeDoc.close();

    const images = iframeDoc.getElementsByTagName("img");
    const loadPromises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        })
    );

    Promise.all(loadPromises).then(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    });
  };

  const handleClassChange = (event) => {
    const classId = event.target.value;
    setSelectedClass(classId);
    fetchData(classId);
  };

  return (
    <div
      ref={printRef}
      style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "40px",
          borderBottom: "1px solid #e5e5e5",
          paddingBottom: "20px",
          gap: "24px",
        }}
      >
        <img
          src={schoolImage ? `${schoolImage}` : ""}
          alt={`school Logo`}
          style={{
            width: "70px",
            height: "70px",
            objectFit: "contain",
            backgroundColor: "#fff",
            padding: "10px",
          }}
        />

        <div>
          <h1
            style={{
              margin: "0",
              fontSize: "20px",
              fontWeight: "600",
              color: "#1a1a1a",
              fontFamily: "'Times New Roman', serif",
              letterSpacing: "0.5px",
            }}
          >
            {schoolName}
          </h1>
          <h2
            style={{
              margin: "6px 0 0",
              fontSize: "18px",
              fontWeight: "500",
              color: "#666",
              fontFamily: "'Times New Roman', serif",
            }}
          >
            {schoolAddress}
          </h2>
          <p
            style={{
              fontSize: "14px",
              color: "#6C757D",
              margin: "6px 0 0",
              fontFamily: "Arial, sans-serif",
            }}
          >
            {schoolEmail}
          </p>
        </div>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <h3>Exam Details</h3>
      </div>

      {loading ? (
        <Spinner size="xl" />
      ) : error ? (
        <Text color="red.500">{error}</Text>
      ) : (
        categories.map((category) => {
          const examsForCategory = exams.filter(
            (exam) => exam.category === category.category
          );

          return (
            examsForCategory.length > 0 && (
              <div key={category.id} style={{ marginBottom: "40px" }}>
                <h3
                  style={{
                    //   fontSize: "28px",
                    //   fontWeight: "bold",
                    //   textAlign: "center",
                    marginBottom: "20px",
                  }}
                >
                  {category.category}
                </h3>
                <Table
                  sx={{
                    "tbody tr:nth-of-type(even)": {
                      backgroundColor: "#f2f4f8",
                    },
                  }}
                  style={{
                    border: "1px solid #d4c2c2", // Border around the table
                    width: "100%",
                    borderCollapse: "collapse", // Ensure borders collapse to a single line
                  }}
                >
                  <Thead>
                    <Tr>
                      <Th
                        style={{
                          border: "1px solid #d4c2c2",
                          padding: "8px",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Exam Name
                      </Th>
                      <Th
                        style={{
                          border: "1px solid #d4c2c2",
                          padding: "8px",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Max Marks
                      </Th>
                      <Th
                        style={{
                          border: "1px solid #d4c2c2",
                          padding: "8px",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Pass Marks
                      </Th>
                      <Th
                        style={{
                          border: "1px solid #d4c2c2",
                          padding: "8px",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Teacher
                      </Th>
                      <Th
                        style={{
                          border: "1px solid #d4c2c2",
                          padding: "8px",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Subject
                      </Th>
                      <Th
                        style={{
                          border: "1px solid #d4c2c2",
                          padding: "8px",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Class
                      </Th>
                      {/* <Th style={{ 
    border: "1px solid #d4c2c2", 
    padding: "8px", 
    textAlign: "center", 
    whiteSpace: "nowrap" 
  }}>
    Category
  </Th> */}
                    </Tr>
                  </Thead>
                  <Tbody>
                    {examsForCategory.map((exam) => (
                      <Tr key={exam.id}>
                        <Td
                          style={{
                            border: "1px solid #d4c2c2",
                            padding: "8px",
                            textAlign: "center",
                          }}
                        >
                          {exam.caption_exam}
                        </Td>
                        <Td
                          style={{
                            border: "1px solid #d4c2c2",
                            padding: "8px",
                            textAlign: "center",
                          }}
                        >
                          {exam.max_marks}
                        </Td>
                        <Td
                          style={{
                            border: "1px solid #d4c2c2",
                            padding: "8px",
                            textAlign: "center",
                          }}
                        >
                          {exam.pass_marks}
                        </Td>
                        <Td
                          style={{
                            border: "1px solid #d4c2c2",
                            padding: "8px",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {exam.name}
                        </Td>
                        <Td
                          style={{
                            border: "1px solid #d4c2c2",
                            padding: "8px",
                            textAlign: "center",
                          }}
                        >
                          {exam.subject}
                        </Td>
                        <Td
                          style={{
                            border: "1px solid #d4c2c2",
                            padding: "8px",
                            textAlign: "center",
                          }}
                        >
                          {exam.class}
                        </Td>
                        {/* <Td style={{ border: "1px solid #d4c2c2", padding: "8px", textAlign: "center" }}>{exam.category}</Td> */}
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </div>
            )
          );
        })
      )}
    </div>
  );
});

export default Print_Pdf_Exam_details;
